import { gql } from '@apollo/client'

export const INSERT_USER_MUTATION = gql`
    mutation insertUserMutation($object: users_user_insert_input!) {
        insert_users_user_one(object: $object) {
            id
        }
    }
`

export const CREATE_ASSET = gql`
    mutation CREATE_ASSET(
        $assetCriticalityLabel: String = ""
        $assetTypeLabel: String = ""
        $asset_type_id: String = ""
        $label: String = ""
        $isMonitored: Boolean = false
        $assetMetaDetails: jsonb = ""
        $description: String = ""
        $ipDetails: jsonb = ""
        $operatingSystem: String = ""
        $tags: jsonb = ""
    ) {
        asset: insert_assets_asset_one(
            object: {
                assetTypeLabel: $assetTypeLabel
                asset_type_id: $asset_type_id
                assetCriticalityLabel: $assetCriticalityLabel
                label: $label
                is_monitored: $isMonitored
                assetMetaDetails: $assetMetaDetails
                description: $description
                ipDetails: $ipDetails
                operatingSystem: $operatingSystem
                tags: $tags
            }
        ) {
            id
            is_monitored
        }
    }
`
export const CREATE_ASSET_BULK = gql`
    mutation createAssetsBulk($objects: [assets_asset_insert_input!]!) {
        insert_assets_asset(objects: $objects) {
            affected_rows
            returning {
                id
            }
        }
    }
`
export const UPDATE_ASSET = gql`
    mutation UPDATE_ASSET(
        $id: String! = ""
        $assetCriticalityLabel: String! = ""
        $assetTypeLabel: String! = ""
        $assetTypeId: String! = ""
        $label: String! = ""
        $isMonitored: Boolean = false
        $assetMetaDetails: jsonb = ""
        $operatingSystem: String = ""
        $ipDetails: jsonb = ""
        $description: String = ""
        $tags: jsonb = ""
    ) {
        update_asset: update_assets_asset_by_pk(
            pk_columns: { id: $id }
            _set: {
                assetCriticalityLabel: $assetCriticalityLabel
                assetTypeLabel: $assetTypeLabel
                asset_type_id: $assetTypeId
                label: $label
                is_monitored: $isMonitored
                assetMetaDetails: $assetMetaDetails
                operatingSystem: $operatingSystem
                ipDetails: $ipDetails
                description: $description
                tags: $tags
            }
        ) {
            updated_at
            id
            is_monitored
        }
    }
`

export const DELETE_ASSET = gql`
    mutation deleteAsset($id: String! = "") {
        delete_assets_asset_by_pk(id: $id) {
            updated_at
        }
    }
`

export const CREATE_INCIDENT = gql`
    mutation CREATE_INCIDENT($object: incidents_incident_insert_input!) {
        incidentData: insert_incidents_incident_one(object: $object) {
            id
        }
    }
`

export const UPDATE_INCIDENT_LOCATION = gql`
    mutation updateIncidentLocation($id: String! = "", $address: String! = "") {
        update_users_organizationLocation_by_pk(
            pk_columns: { id: $id }
            _set: { address: $address }
        ) {
            id
        }
    }
`

export const CREATE_INCIDENT_LOCATION = gql`
    mutation createIncidentLocation($address: String! = "") {
        location: insert_users_organizationLocation_one(
            object: { address: $address }
            on_conflict: {
                constraint: organizationLocation_address_organizationId_key
                update_columns: address
            }
        ) {
            address
            id
        }
    }
`

export const UPDATE_INCIDENT = gql`
    mutation UPDATE_INCIDENT(
        $_set: incidents_incident_set_input = {}
        $_eq: String = ""
    ) {
        update_incidents_incident(_set: $_set, where: { id: { _eq: $_eq } }) {
            affected_rows
        }
    }
`

export const INSERT_INCIDENT_ASSET = gql`
    mutation insertIncidentAsset(
        $objects: [incidents_incident_assets_insert_input!]! = {}
    ) {
        insert_incidents_incident_assets(objects: $objects) {
            affected_rows
        }
    }
`

export const DELETE_INCIDENT_ASSETS = gql`
    mutation deleteIncidentAssets($incidentId: String!, $assetIds: [String!]) {
        delete_incidents_incident_assets(
            where: {
                incidentId: { _eq: $incidentId }
                assetId: { _in: $assetIds }
            }
        ) {
            affected_rows
        }
    }
`

export const UPDATE_USER = gql`
    mutation UPDATE_USER($id: String! = "", $_set: users_user_set_input) {
        update_user: update_users_user_by_pk(
            pk_columns: { id: $id }
            _set: $_set
        ) {
            id
        }
    }
`

export const DELETE_USER = gql`
    mutation DELETE_USER($id: String!) {
        deleteUser: delete_users_user_by_pk(id: $id) {
            id
            email
        }
    }
`

export const DELETE_USER_WORKROLES = gql`
    mutation deleteUserWorkroles(
        $userId: String = ""
        $workRoleIds: [String!]
    ) {
        delete_users_user_workRole(
            where: {
                userId: { _eq: $userId }
                workRoleId: { _in: $workRoleIds }
            }
        ) {
            affected_rows
        }
    }
`

export const INSERT_USER_WORKROLES = gql`
    mutation insertUserWorkroles(
        $objects: [users_user_workRole_insert_input!]!
    ) {
        insert_users_user_workRole(objects: $objects) {
            affected_rows
        }
    }
`

export const UPDATE_INCIDENT_NOTES = gql`
    mutation UPDATE_INCIDENT_NOTES(
        $incidentId: String! = ""
        $notes: String = ""
    ) {
        update_incidents_incident_by_pk(
            pk_columns: { id: $incidentId }
            _set: { notes: $notes }
        ) {
            id
        }
    }
`

export const UPDATE_TASK_NOTES = gql`
    mutation UPDATE_TASK_NOTES(
        $taskId: String! = ""
        $incidentId: String! = ""
        $notes: String = ""
    ) {
        update_tasks_task(
            where: { id: { _eq: $taskId }, incidentId: { _eq: $incidentId } }
            _set: { notes: $notes }
        ) {
            affected_rows
        }
    }
`

export const UPDATE_TASK_STATUS = gql`
    mutation UPDATE_TASK_STATUS($id: String! = "", $status: String! = "") {
        update_tasks_task_by_pk(
            pk_columns: { id: $id }
            _set: { status: $status }
        ) {
            id
        }
    }
`

export const UPDATE_TASK_ASSIGNEE = gql`
    mutation updateTaskAssignee($taskId: String!, $assignedTo: String!) {
        update: update_tasks_task_by_pk(
            pk_columns: { id: $taskId }
            _set: { assignedTo: $assignedTo, isManuallyAssigned: true }
        ) {
            assignedTo
        }
    }
`

export const UPDATE_ORG_LEGALNAME = gql`
    mutation updateOrgLegalname($id: String! = "", $var: String = "") {
        update_users_organization_by_pk(
            pk_columns: { id: $id }
            _set: { legalName: $var }
        ) {
            industrySector
            size
            legalName
            address
        }
    }
`

export const UPDATE_ORG_ADDRESS = gql`
    mutation UPDATE_ORG_ADDRESS($id: String! = "", $var: String = "") {
        update_users_organization_by_pk(
            pk_columns: { id: $id }
            _set: { address: $var }
        ) {
            industrySector
            size
            legalName
            address
        }
    }
`

export const UPDATE_ORG_INDUSTRY = gql`
    mutation updateOrgIndustry($id: String! = "", $var: String = "") {
        update_users_organization_by_pk(
            pk_columns: { id: $id }
            _set: { industrySector: $var }
        ) {
            industrySector
            size
            legalName
            address
        }
    }
`
export const UPDATE_ORG_SIZE = gql`
    mutation UPDATE_ORG_SIZE($id: String! = "", $var: String = "") {
        update_users_organization_by_pk(
            pk_columns: { id: $id }
            _set: { size: $var }
        ) {
            industrySector
            size
            org_size_id
            legalName
            address
        }
    }
`

export const UPDATE_ORG_ATTACHMENTS = gql`
    mutation updateOrgAttachments($id: String! = "", $attachments: jsonb = "") {
        update: update_users_organization_by_pk(
            pk_columns: { id: $id }
            _set: { attachments: $attachments }
        ) {
            id
        }
    }
`

export const ARCHIVE_TASK_ARTIFACT = gql`
    mutation ARCHIVE_TASK_ARTIFACT($taskArtifactId: String! = "") {
        archiveTask: update_tasks_taskArtifact_by_pk(
            pk_columns: { id: $taskArtifactId }
            _set: { archived: true }
        ) {
            s3Key
        }
    }
`

export const INCREMENT_RESEND_INVITE = gql`
    mutation incrementResendInvite($id: String!) {
        update_users_user_by_pk(
            pk_columns: { id: $id }
            _inc: { resendInviteAttempt: 1 }
        ) {
            id
        }
    }
`
export const DELETE_INCIDENT_BY_ID = gql`
    mutation DELETE_INCIDENT_BY_ID($incidentId: String! = "") {
        delete_incidents_incident_by_pk(id: $incidentId) {
            id
        }
    }
`

export const INCREMENT_UNASSIGN_TASK_ATTEMPT = gql`
    mutation incrementUnassignTaskAttempt($id: String!) {
        update_users_user_by_pk(
            pk_columns: { id: $id }
            _inc: { unassignTasksAttempt: 1 }
        ) {
            id
        }
    }
`

export const UPDATE_USER_WORK_ROLE_VIA_AUTO_ASSIGN = gql`
    mutation updateUserWorkRoleViaAutoAssign(
        $userId: String! = ""
        $workRoleId: String! = ""
        $object: users_user_workRole_set_input! = {}
    ) {
        update_users_user_workRole_by_pk(
            pk_columns: { userId: $userId, workRoleId: $workRoleId }
            _inc: { reassignTasksAttempt: 1 }
            _set: $object
        ) {
            updated_at
        }
    }
`

export const UPDATE_INCIDENT_RESOLVED_STATUS = gql`
    mutation UPDATE_INCIDENT_RESOLVED_STATUS(
        $incidentId: String! = ""
        $object: incidents_incident_set_input = {}
    ) {
        update_incidents_incident_by_pk(
            pk_columns: { id: $incidentId }
            _set: $object
        ) {
            isResolved
        }
    }
`

export const UPDATE_USER_NOTIFICATION_DATA = gql`
    mutation UPDATE_USER_NOTIFICATION_DATA(
        $userId: String! = ""
        $lastSeenNotificationId: String! = ""
    ) {
        update_users_user_by_pk(
            pk_columns: { id: $userId }
            _set: { lastSeenNotificationId: $lastSeenNotificationId }
        ) {
            id
        }
    }
`

export const UPDATE_SUBTASK_IS_COMPLETED = gql`
    mutation UPDATE_SUBTASK_IS_COMPLETED(
        $id: String! = ""
        $_set: tasks_subTask_set_input! = {}
    ) {
        update_tasks_subTask_by_pk(pk_columns: { id: $id }, _set: $_set) {
            id
        }
    }
`

export const INSERT_INCIDENT_TEMPLATE = gql`
    mutation insertIncidentTemplate(
        $object: incidents_incidentTemplateByOrganization_insert_input! = {}
    ) {
        insert_incidents_incidentTemplateByOrganization_one(
            object: $object
            on_conflict: {
                constraint: incidentTemplateByOrganization_pkey
                update_columns: incidentTemplate
            }
        ) {
            incidentTemplate
        }
    }
`

export const UPDATE_INCIDENT_TEMPLATE = gql`
    mutation updateIncidentTemplate(
        $incidentTemplate: jsonb = ""
        $incidentTypeId: String! = ""
    ) {
        update_incidents_incidentTemplateByOrganization(
            where: { incidentTypeId: { _eq: $incidentTypeId } }
            _set: { incidentTemplate: $incidentTemplate }
        ) {
            affected_rows
        }
    }
`

export const INSERT_INCIDENT_TYPE = gql`
    mutation insertIncidentType(
        $object: incidents_incidentType_insert_input! = {}
    ) {
        incidentType: insert_incidents_incidentType_one(object: $object) {
            id
        }
    }
`

export const INSERT_METADESCRIPTION = gql`
    mutation insertMetadescription(
        $objects: [master_metaDescription_insert_input!]! = {}
    ) {
        metadescription: insert_master_metaDescription(objects: $objects) {
            affected_rows
            returning {
                id
            }
        }
    }
`

export const DELETE_INCIDENT_TEMPLATE_BY_ORG = gql`
    mutation deleteIncidentTemplateByOrganisation(
        $organizationId: String! = ""
        $incidentTypeId: String! = ""
    ) {
        delete_incidents_incidentTemplateByOrganization_by_pk(
            incidentTypeId: $incidentTypeId
            organizationId: $organizationId
        ) {
            incidentTemplate
        }
    }
`

export const UPDATE_INCIDENT_TYPE_BY_ID = gql`
    mutation updateIncidentTypeById(
        $incidentTypeId: String! = ""
        $_set: incidents_incidentType_set_input! = {}
    ) {
        update_incidents_incidentType_by_pk(
            pk_columns: { id: $incidentTypeId }
            _set: $_set
        ) {
            id
        }
    }
`

export const UPDATE_META_DESCRIPTION_BY_ID = gql`
    mutation updateMetaDescriptionContent(
        $id: String! = ""
        $contentBody: String! = ""
    ) {
        update_master_metaDescription_by_pk(
            pk_columns: { id: $id }
            _set: { contentBody: $contentBody }
        ) {
            contentBody
        }
    }
`

export const UPDATE_ORG_TIMEZONE = gql`
    mutation updateOrgTimezone($id: String! = "", $timezone: jsonb! = "") {
        update_users_organization_by_pk(
            pk_columns: { id: $id }
            _set: { timezone: $timezone }
        ) {
            timezone
        }
    }
`

export const UPDATE_RISK_MANAGEMENT_QUESTION_BY_ID = gql`
    mutation updateRiskMangementQuestion(
        $id: String! = ""
        $_set: riskManagement_rmLogQuestion_set_input! = {}
    ) {
        update_riskManagement_rmLogQuestion_by_pk(
            pk_columns: { id: $id }
            _set: $_set
        ) {
            id
        }
    }
`
export const UPDATE_RISK_MANAGEMENT_MULTIPLE_QUESTION = gql`
    mutation updateRiskMangementQuestion(
        $ids: [String!]!
        $_set: riskManagement_rmLogQuestion_set_input!
    ) {
        update_riskManagement_rmLogQuestion(
            where: { id: { _in: $ids } }
            _set: $_set
        ) {
            affected_rows
            returning {
                id
            }
        }
    }
`
export const CREATE_RISK_MANAGEMENT_LOG = gql`
    mutation MyMutation(
        $object: riskManagement_riskManagementLog_insert_input!
    ) {
        insert_riskManagement_riskManagementLog_one(object: $object) {
            id
        }
    }
`
export const UPDATE_ALERT_THRESHOLD_SETTINGS = gql`
    mutation INSERT_ALERT_ESCALATE_SETTING(
        $object: alerts_alertOrgSetting_insert_input!
    ) {
        insert_alerts_alertOrgSetting_one(
            object: $object
            on_conflict: {
                constraint: alertOrgSetting_pkey
                update_columns: alertCriticalityLevel
            }
        ) {
            alertCriticalityLevel
            alertHandleStatus
            organizationId
        }
    }
`
export const UNLINK_ALERT_INCIDENT = gql`
    mutation unlinkAlertIncident($alertId: String!, $incidentId: String!) {
        delete_alerts_alert_incident_by_pk(
            alertId: $alertId
            incidentId: $incidentId
        ) {
            alertId
        }
    }
`

// TODO ts - check this
export const REMOVE_AND_LINK_ALERTS_TO_INCIDENT = gql`
    mutation removeAndLinkAlertsToIncident(
        $alertIdList: [String!]!
        $objects: [alerts_alert_incident_insert_input!]!
    ) {
        delete_alerts_alert_incident(
            where: { alertId: { _in: $alertIdList } }
        ) {
            affected_rows
            returning {
                alertId
            }
        }
        insert_alerts_alert_incident(
            objects: $objects
            on_conflict: { constraint: alert_incident_pkey }
        ) {
            affected_rows
            returning {
                alertId
                incidentId
            }
        }
    }
`
export const DELETE_ALERT_INCIDENTS = gql`
    mutation DELETE_ALERT_INCIDENTS($alertIdList: [String!]!) {
        delete_alerts_alert_incident(
            where: { alertId: { _in: $alertIdList } }
        ) {
            affected_rows
            returning {
                alertId
            }
        }
    }
`
export const INSERT_ALERT_INCIDENT = gql`
    mutation INSERT_ALERT_INCIDENT(
        $objects: [alerts_alert_incident_insert_input!]!
    ) {
        insert_alerts_alert_incident(
            objects: $objects
            on_conflict: { constraint: alert_incident_pkey }
        ) {
            returning {
                incidentId
                alertId
            }
        }
    }
`
export const INSERT_ALERT_ASSETS_TO_INCIDENT = gql`
    mutation alertAssetsToIncident(
        $objects: [incidents_incident_assets_insert_input!]!
    ) {
        insert_incidents_incident_assets(
            # on_conflict: { constraint: incident_assets_assetId_incidentId_key }
            objects: $objects
        ) {
            affected_rows
        }
    }
`
export const INSERT_CUSTOMER_PAYMENT_METHOD = gql`
    mutation insertCustomerPaymentMethod(
        $objects: [payments_paymentMethod_insert_input!]!
    ) {
        insert_payments_paymentMethod(objects: $objects) {
            returning {
                brand
                cardholderName
                cvcCheck
                expMonth
                expYear
                funding
                id
                last4digits
                stripePaymentMethodId
                stripeCustomerId
                organizationId
            }
        }
    }
`
export const DELETE_PAYMENT_METHOD = gql`
    mutation deletePaymentMeThod($paymentMethodId: String!) {
        delete_payments_paymentMethod_by_pk(id: $paymentMethodId) {
            id
            stripePaymentMethodId
        }
    }
`
export const UPDATE_PAYMENT_METHOD_ID_ORG = gql`
    mutation updatePaymentIdInOrg(
        $_set: users_organization_set_input!
        $orgId: String!
    ) {
        update_users_organization(_set: $_set, where: { id: { _eq: $orgId } }) {
            affected_rows
        }
    }
`
export const UPDATE_PAYMENT_ATTEMPT = gql`
    mutation updateIncreaseAttempt($id: String!) {
        update_payments_invoice_by_pk(
            pk_columns: { id: $id }
            _inc: { attempt: 1 }
        ) {
            id
            status
        }
    }
`
export const INSERT_INVOICE = {
    INSERT: gql`
        mutation insertInvoice($objects: [payments_invoice_insert_input!]!) {
            invoiceDetail: insert_payments_invoice(objects: $objects) {
                returning {
                    id
                    status
                }
            }
        }
    `,
}
export const UPDATE_ORGANIZATION_DETAILS = gql`
    mutation updateOrgDetails(
        $_set: users_organization_set_input!
        $orgId: String!
    ) {
        updateOrgDetails: update_users_organization_by_pk(
            pk_columns: { id: $orgId }
            _set: $_set
        ) {
            planDetails
            billingEmail
        }
    }
`

export const INSERT_TEMPLATE = gql`
    mutation insertTemplate($template: jsonb!) {
        insert_templates_template(objects: { template: $template }) {
            returning {
                template
                id
            }
        }
    }
`

export const UPDATE_TEMPLATE = gql`
    mutation updateTemplate($template: jsonb!, $id: String!) {
        update_templates_template(
            where: { id: { _eq: $id } }
            _set: { template: $template }
        ) {
            returning {
                id
                template
            }
        }
    }
`

export const DELETE_TEMPLATE = gql`
    mutation deleteTemplate($id: String!) {
        templates: delete_templates_template(where: { id: { _eq: $id } }) {
            returning {
                id
                template
            }
        }
    }
`

export const INSERT_TASK = gql`
    mutation INSERT_TASK($tasks: [tasks_task_insert_input!]!) {
        insertedTasks: insert_tasks_task(objects: $tasks) {
            tasks: returning {
                id
                taskBoard {
                    id
                    label
                }
                incidentId
            }
        }
    }
`

export const INSERT_WORKROLE = gql`
    mutation INSERT_WORKROLE($object: master_workRole_insert_input!) {
        insert_master_workRole_one(object: $object) {
            label
            metaDescription {
                contentBody
            }
        }
    }
`

export const UPDATE_WORKROLE = gql`
    mutation UPDATE_WORKROLE(
        $id: String!
        $label: String!
        $description: String!
        $type: String!
        $descriptionId: String!
    ) {
        update_master_workRole(
            where: { id: { _eq: $id } }
            _set: { label: $label, type: $type }
        ) {
            returning {
                label
                type
            }
        }
        update_master_metaDescription_by_pk(
            pk_columns: { id: $descriptionId }
            _set: { contentBody: $description }
        ) {
            contentBody
        }
    }
`

export const CREATE_ALERT_GROUP = gql`
    mutation CREATE_ALERT_GROUP($alertGroup: alerts_alertGroup_insert_input!) {
        insertedGroup: insert_alerts_alertGroup_one(object: $alertGroup) {
            id
            created_at
            alerts: alerts_aggregate {
                aggregate {
                    count
                }
            }
            createdByUser {
                firstName
                lastName
            }
        }
    }
`

export const CREATE_ALERT_DISPOSITION = gql`
    mutation CREATE_ALERT_DISPOSITION(
        $disposition: master_alert_disposition_insert_input!
    ) {
        insert_master_alert_disposition_one(object: $disposition) {
            id
        }
    }
`

// TODO ts - check this
export const MERGE_ALERT_GROUPS = gql`
    mutation MERGE_ALERT_GROUPS(
        $baseGroupId: String!
        $targetGroupId: String!
        $dispositionIds: [String!]
    ) {
        updatedAlerts: update_alerts_alert(
            where: {
                groupId: { _eq: $baseGroupId }
                dispositionId: { _in: $dispositionIds }
            }
            _set: { groupId: $targetGroupId }
        ) {
            affected_rows
        }
    }
`
export const MOVE_ALERTS_IN_GROUP_TO_DISPOSITION = gql`
    mutation MOVE_ALERTS_IN_GROUP_TO_DISPOSITION(
        $baseGroupId: String!
        $targetDispositionId: String!
    ) {
        updatedAlerts: update_alerts_alert_hp(
            _set: { dispositionId: $targetDispositionId }
            where: { groupId: { _eq: $baseGroupId } }
        ) {
            count: affected_rows
        }
    }
`

// TODO ts - check this
export const MOVE_ALERTS_IN_ASSETS_AND_DISPOSITION_TO_DISPOSITION = gql`
    mutation MOVE_ALERTS_IN_GROUP_TO_DISPOSITION(
        $baseAssetId: String!
        $targetDispositionId: String!
        $activeDisposition: String!
    ) {
        updatedAlerts: update_alerts_alert(
            _set: { dispositionId: $targetDispositionId }
            where: {
                _and: [
                    { dispositionId: { _neq: $targetDispositionId } }
                    { dispositionId: { _eq: $activeDisposition } }
                ]
                assetId: { _eq: $baseAssetId }
            }
        ) {
            count: affected_rows
        }
    }
`

export const MOVE_ASSET_TO_DISPOSITION = gql`
    mutation MOVE_ASSET_TO_DISPOSITION(
        $assetId: String!
        $targetDispositionId: String!
    ) {
        updatedAlerts: update_alerts_alert_hp(
            where: { _and: { assetId: { _eq: $assetId } } }
            _set: { dispositionId: $targetDispositionId }
        ) {
            count: affected_rows
        }
    }
`
// TODO ts - check this
export const MOVE_RULE_TO_DISPOSITION = gql`
    mutation MOVE_RULE_TO_DISPOSITION(
        $ruleId: String!
        $targetDispositionId: String!
    ) {
        updatedAlerts: update_alerts_alert(
            _set: { dispositionId: $targetDispositionId }
            where: { ruleId: { _eq: $ruleId } }
        ) {
            count: affected_rows
        }
    }
`

export const UPDATE_ALERT_GROUP_ONE = gql`
    mutation UPDATE_ALERT_GROUP_ONE(
        $groupId: String!
        $label: String!
        $description: String!
    ) {
        alertGroup: update_alerts_alertGroup_by_pk(
            pk_columns: { id: $groupId }
            _set: { label: $label, description: $description }
        ) {
            id
        }
    }
`

export const DELETE_ALERT_GROUP_ONE = gql`
    mutation DELETE_ALERT_GROUP_ONE($groupId: String!) {
        delete_alerts_alertGroup_by_pk(id: $groupId) {
            id
        }
    }
`
export const UPDATE_ALERT_DISPOSITION_ONE = gql`
    mutation UPDATE_ALERT_DISPOSITION_ONE(
        $label: String!
        $id: String!
        $description: String!
        $isOpen: Boolean!
    ) {
        update_master_alert_disposition_by_pk(
            pk_columns: { id: $id }
            _set: { label: $label, description: $description, isOpen: $isOpen }
        ) {
            id
        }
    }
`

export const DELETE_ALERT_DISPOSITION = gql`
    mutation DELETE_ALERT_DISPOSITION($id: String!) {
        delete_master_alert_disposition_by_pk(id: $id) {
            id
        }
    }
`

export const UPSERT_DISPOSITION_IN_OSSEC_RULE_PREFERENCE = gql`
    mutation upsert_ossecRulesPreferennce(
        $objects: [master_ossecRules_preference_insert_input!]!
        $update_columns: [master_ossecRules_preference_update_column!]!
    ) {
        upsertDisposition: insert_master_ossecRules_preference(
            objects: $objects
            on_conflict: {
                constraint: ossecRules_preference_ruleId_organizationId_key
                update_columns: $update_columns
            }
        ) {
            affected_rows
            returning {
                id
                ruleId
                defaultDispositionId
                ignoreAlerts
            }
        }
    }
`

// TODO ts - check this
export const INSERT_ALERT_ASSET = gql`
    mutation insertAlertAsset($objects: [alerts_alert_asset_insert_input!]!) {
        insertAlertAsset: insert_alerts_alert_asset(
            objects: $objects
            on_conflict: { constraint: alert_asset_pkey, update_columns: [] }
        ) {
            affected_rows
            returning {
                assetId
                alertId
            }
        }
    }
`

// TODO ts - check this
export const REMOVE_AND_LINK_ALERTS_TO_ASSET = gql`
    mutation removeAndLinkAlertsToAsset(
        $alertIdList: [String!]!
        $objects: [alerts_alert_asset_insert_input!]!
    ) {
        delete_alerts_alert_asset(where: { alertId: { _in: $alertIdList } }) {
            affected_rows
            returning {
                alertId
            }
        }
        insert_alerts_alert_asset(
            objects: $objects
            on_conflict: { constraint: alert_asset_pkey, update_columns: [] }
        ) {
            affected_rows
            returning {
                alertId
                assetId
            }
        }
    }
`

// TODO ts - check this
export const UPDATE_ALERT_DISPOSITION = gql`
    mutation updateDisposition($incidentId: String!, $dispositionId: String!) {
        update_alerts_alert(
            where: { alert_incidents: { incidentId: { _eq: $incidentId } } }
            _set: { dispositionId: $dispositionId }
        ) {
            affected_rows
            returning {
                id
            }
        }
    }
`

export const UPDATE_MULTIPLE_TASKS = gql`
    mutation updateMultipleTasks($status: String!, $taskIds: [String!]!) {
        update_tasks_task(
            where: { id: { _in: $taskIds } }
            _set: { status: $status }
        ) {
            affected_rows
        }
    }
`
export const REMOVE_RACI_RESPONSIBILITY = gql`
    mutation REMOVE_RACI_RESPONSIBILITY($id: String!) {
        removeRaciResponsibility: delete_raci_responsibility_by_pk(id: $id) {
            id
        }
    }
`
export const UPSERT_RACI_ROLE_MAPPING = gql`
    mutation UPSERT_RACI_ROLE_MAPPING(
        $raciRoleId: String!
        $raciUserId: String!
        $responsibilityId: String!
    ) {
        upsertRaciRoleMapping: insert_raci_raciMapping_one(
            object: {
                raciRoleId: $raciRoleId
                raciUserId: $raciUserId
                resposibilityId: $responsibilityId
            }
            on_conflict: {
                constraint: raciMapping_pkey
                update_columns: raciRoleId
            }
        ) {
            id
        }
    }
`
export const REMOVE_RACI_USER = gql`
    mutation REMOVE_RACI_USER($id: String!) {
        removeRaciUser: delete_raci_raciUser_by_pk(id: $id) {
            id
        }
    }
`
export const INSERT_RACI_USER = gql`
    mutation INSERT_RACI_USER($object: raci_raciUser_insert_input!) {
        insertRaciUser: insert_raci_raciUser_one(object: $object) {
            id
        }
    }
`
export const INSERT_RACI_RESPONSIBILITY = gql`
    mutation INSERT_RACI_RESPONSIBILITY(
        $label: String!
        $description: String = ""
    ) {
        insertRaciResponsibility: insert_raci_responsibility_one(
            object: { label: $label, description: $description }
        ) {
            id
            label
        }
    }
`
export const UPDATE_RACI_RESPONSIBILITY = gql`
    mutation UPDATE_RACI_RESPONSIBILITY(
        $id: String!
        $label: String!
        $description: String = ""
    ) {
        updateRaciResponsibility: update_raci_responsibility_by_pk(
            pk_columns: { id: $id }
            _set: { label: $label, description: $description }
        ) {
            id
        }
    }
`

export const DELETE_RACI_MAPPING_ONE = gql`
    mutation DELETE_RACI_MAPPING_ONE(
        $raciUserId: String!
        $raciResponsibilityId: String!
    ) {
        delete_raci_raciMapping_by_pk(
            raciUserId: $raciUserId
            resposibilityId: $raciResponsibilityId
        ) {
            id
        }
    }
`

export const UPDATE_INTEGRATION_STATUS = gql`
    mutation UPDATE_INTEGRATION_STATUS(
        $integrationId: String!
        $status: Boolean!
    ) {
        update_users_organization_integration(
            where: { id: { _eq: $integrationId } }
            _set: { isActive: $status }
        ) {
            returning {
                id
            }
        }
    }
`
export const UPDATE_TASK_TASKSTAGE = gql`
    mutation UPDATE_TASK_TASKSTAGE(
        $incidentId: String!
        $taskId: String!
        $taskBoardId: String!
    ) {
        updateTaskStage: update_tasks_task(
            where: { incidentId: { _eq: $incidentId }, id: { _eq: $taskId } }
            _set: { taskBoardId: $taskBoardId }
        ) {
            affected_rows
        }
    }
`
export const MOVE_ALERT_HP_TO_DISPOSITION = gql`
    mutation MOVE_ALERT_HP_TO_DISPOSITION(
        $alertsWhere: alerts_alert_hp_bool_exp!
        $dispositionId: String!
    ) {
        updatedAlerts: update_alerts_alert_hp(
            where: $alertsWhere
            _set: { dispositionId: $dispositionId }
        ) {
            affected_rows
        }
    }
`

export const MOVE_ALL_ALERT_HP_TO_DISPOSITION = gql`
    mutation MOVE_ALL_ALERT_HP_TO_DISPOSITION(
        $alertsWhere: alerts_alert_hp_bool_exp!
        $dispositionId: String!
    ) {
        updatedAlerts: update_alerts_alert_hp(
            where: $alertsWhere
            _set: { dispositionId: $dispositionId }
        ) {
            affected_rows
        }
    }
`

export const MOVE_ALERTS_HP_TO_GROUP = gql`
    mutation MOVE_ALERTS_HP_TO_GROUP(
        $alertsWhere: alerts_alert_hp_bool_exp!
        $groupId: String!
    ) {
        updatedAlerts: update_alerts_alert_hp(
            where: $alertsWhere
            _set: { groupId: $groupId }
        ) {
            count: affected_rows
        }
    }
`
export const MOVE_ALL_ALERT_HP_TO_GROUP = gql`
    mutation MOVE_ALL_ALERT_HP_TO_GROUP(
        $alertsWhere: alerts_alert_hp_bool_exp!
        $groupId: String!
    ) {
        updatedAlerts: update_alerts_alert_hp(
            where: $alertsWhere
            _set: { groupId: $groupId }
        ) {
            count: affected_rows
        }
    }
`

export const INSERT_INCIDENT_TO_ALERT = gql`
    mutation INSERT_INCIDENT_TO_ALERT(
        $objects: [alerts_alert_incident_insert_input!]!
    ) {
        insert_alerts_alert_incident(
            objects: $objects
            on_conflict: { constraint: alert_incident_pkey }
        ) {
            returning {
                incidentId
                alertId
            }
            affected_rows
        }
    }
`

export const INSERT_DEFAULT_SIMULATION = gql`
    mutation INSERT_DEFAULT_SIMULATION {
        inserted_row: insert_simulation_simulation_one(object: {}) {
            id
            created_at
            updated_at
        }
    }
`

export const INSERT_SIMULATED_INCIDENT = gql`
    mutation INSERT_SIMULATED_INCIDENT(
        $incident: incidents_incident_insert_input! = {}
    ) {
        inserted_row: insert_incidents_incident_one(object: $incident) {
            id
        }
    }
`

export const INSERT_SIMULATED_INCIDENT_PARAMS = gql`
    mutation INSERT_SIMULATED_INCIDENT_PARAMS(
        $incidentId: String
        $simulationParams: jsonb!
        $invited_users: [simulation_invited_users_insert_input!]!
    ) {
        inserted_simulation_row: insert_simulation_incident_one(
            object: { incidentId: $incidentId, parameters: $simulationParams }
        ) {
            incidentId
        }
        users_invited_with_email: insert_simulation_invited_users(
            objects: $invited_users
        ) {
            affected_rows
        }
    }
`

export const INSERT_INCIDENT_INJECT = gql`
    mutation INSERT_INCIDENT_INJECT(
        $injectId: String!
        $incidentId: String!
        $impact: String!
        $urgency: String!
    ) {
        insert_simulation_incident_inject_one(
            object: {
                injectId: $injectId
                incidentId: $incidentId
                impact: $impact
                urgency: $urgency
            }
        ) {
            __typename
        }
    }
`

export const INSERT_INJECT = gql`
    mutation INSERT_INJECT($inject: injects_inject_insert_input!) {
        insertedRow: insert_injects_inject_one(object: $inject) {
            id
        }
    }
`

export const SEND_PING = gql`
    mutation SEND_PING {
        insert_simulation_activeUsers_one(
            object: { lastPing: 0 }
            on_conflict: {
                constraint: activeUsers_pkey
                update_columns: [lastPing]
            }
        ) {
            userId
        }
    }
`

export const UPDATE_TASK_ACTION_RESPONSE = gql`
    mutation UPDATE_TASK_ACTION_RESPONSE(
        $subTaskId: String!
        $answeredKey: Int!
    ) {
        updated: update_simulation_taskActionResponse(
            where: { subTaskId: { _eq: $subTaskId } }
            _set: { answeredKey: $answeredKey }
        ) {
            affected_rows
        }
    }
`

export const UPSERT_ORG_SUBSCRIPTION_METADATA = gql`
    mutation UPSERT_ORG_SUBSCRIPTION_METADATA(
        $subscription_type: String!
        $plan_subscription_from: Int!
        $plan_subscription_until: Int!
        $current_cycle_ends_on: Int!
        $invoice_with_email: Boolean!
    ) {
        insert_users_organization_subscription_one(
            object: {
                subscription_type: $subscription_type
                plan_subscription_from: $plan_subscription_from
                plan_subscription_until: $plan_subscription_until
                current_cycle_ends_on: $current_cycle_ends_on
                invoice_with_email: $invoice_with_email
            }
            on_conflict: {
                constraint: organization_subscription_pkey
                update_columns: [invoice_with_email]
            }
        ) {
            organization_id
        }
    }
`
export const UPSERT_ORG_SUBSCRIPTION_METADATA_WITH_TYPE = gql`
    mutation UPSERT_ORG_SUBSCRIPTION_METADATA(
        $subscription_type: String!
        $plan_subscription_from: Int!
        $plan_subscription_until: Int!
        $current_cycle_ends_on: Int!
        $invoice_with_email: Boolean!
    ) {
        insert_users_organization_subscription_one(
            object: {
                subscription_type: $subscription_type
                plan_subscription_from: $plan_subscription_from
                plan_subscription_until: $plan_subscription_until
                current_cycle_ends_on: $current_cycle_ends_on
                invoice_with_email: $invoice_with_email
            }
            on_conflict: {
                constraint: organization_subscription_pkey
                update_columns: [
                    subscription_type
                    plan_subscription_from
                    plan_subscription_until
                    current_cycle_ends_on
                    invoice_with_email
                ]
                where: { subscription_type: { _eq: "TRIAL" } }
            }
        ) {
            organization_id
        }
    }
`

export const UPDATE_ORG_ACTION_ITEM = gql`
    mutation UPDATE_ORG_ACTION_ITEM($id: String!, $done: Boolean!) {
        update_users_organization_recommmended_action_by_pk(
            pk_columns: { id: $id }
            _set: { done: $done }
        ) {
            id
        }
    }
`

export const UPDATE_PLAYBOOK_STATUS = gql`
    mutation UPDATE_PLAYBOOK_STATUS($id: String!, $status: String!) {
        update_incidents_incidentType_by_pk(
            pk_columns: { id: $id }
            _set: { status: $status }
        ) {
            id
        }
    }
`

export const UPDATE_TEMPLATE_STATUS = gql`
    mutation UPDATE_TEMPLATE_STATUS($id: String!, $status: String!) {
        update_templates_template_by_pk(
            pk_columns: { id: $id }
            _set: { status: $status }
        ) {
            id
        }
    }
`

export const UPSERT_LAST_SEEN_COMMENT = gql`
    mutation UPSERT_LAST_SEEN_COMMENT(
        $incidentId: String!
        $commentId: String!
    ) {
        upserted: insert_incidents_incident_chat_last_seen_message_one(
            object: {
                incident_id: $incidentId
                last_seen_comment_id: $commentId
            }
            on_conflict: {
                constraint: incident_chat_last_seen_message_pkey
                update_columns: [last_seen_comment_id]
            }
        ) {
            __typename
            user_id
        }
    }
`
